<template>
    <div>
        <div class="card" v-if="filtros.length">
            <div class="card-footer" v-if="filtros.length">
                <div class="btn-group mb-2 mr-2" role="group" aria-label="Basic example" v-for="(filtro, ifl) in filtros" :key="ifl">
                    <button type="button" class="btn btn-outline-primary btn-sm">
                        {{ filtro.campo.title }} {{ filtro.tipo == 'E' ? '!=' : '=' }} {{ filtro.valor }}
                    </button>
                    <button type="button" class="btn btn-outline-primary btn-sm" @click="removerFiltro(ifl)">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Modal Add Filtro -->
        <div class="modal fade" id="filtroCampoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="campoFiltro">
                    <div class="modal-header">
                    <h5 class="modal-title">
                        Filtrar
                        {{ campoFiltro.title }}
                        <span class="badge badge-secondary" v-if="opcoesFiltroSelecionadas.length">
                            {{ opcoesFiltroSelecionadas.length }}
                        </span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div class="modal-body">
                    <az-input icon="fa fa-search fa-fw" sizing="sm" class="mb-3" v-model="search" placeholder="Pesquisar..." />

                    <az-input
                        class="mb-3"
                        type="button-group"
                        :optionsList="[
                        { id: 'A', search: 'Apenas' },
                        { id: 'E', search: 'Exceto' },
                        ]"
                        v-model="tipoFiltro" />

                    <button type="button" class="btn btn-outline-primary btn-sm mb-3" @click="toggle_todos()">Todos</button>

                    <div class="row" v-for="(opt, iopt) in exibirOpcoesFiltro" :key="iopt">
                        <div class="col">
                        <az-input sizing="sm" type="checkbox-group" :label="'  ' + opt.label" v-model="opt.selecionado" v-if="iopt < slice_filtro"/>
                        <label class="form form-control" v-else>...</label>
                        </div>
                    </div>

                    <div class="alert mt-3" :class="tipoFiltro == 'E' ? 'alert-danger' : 'alert-info'" v-if="opcoesFiltroSelecionadas.length">
                        <small>
                            Selecioandos:
                            {{ tipoFiltro == 'E' ? '(EXCETO)' : '' }}
                            {{ opcoesFiltroSelecionadas.map(item => item.label).join(', ') }}
                        </small>
                    </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="addFiltroFromModal()">Filtrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            opcoesFiltro: [],
            campoFiltro: {},
            tipoFiltro: 'A',
            search: '', 
            slice_filtro: 100,
            filtros: [], 
        };
    },

    components: { 
        AzInput, 
    },

    computed: { 
        opcoesFiltroSelecionadas: function () {
            return this.opcoesFiltro.filter((item) => item.selecionado);
        },

        exibirOpcoesFiltro: function () {
            return this.opcoesFiltro.filter((item) => item.label !== null && ( !this.search || item.label.toString().toUpperCase().indexOf(this.search.toUpperCase())) >= 0)
                .slice(0, this.slice_filtro + 1);
        },
    },
    
    methods: {
        refresh_filtro () { 
            this.$parent.filtros = _.cloneDeep(this.filtros);
        },

        removerFiltro(index) {
            this.filtros.splice(index, 1);
            this.refresh_filtro();
        },

        replaceFiltro(campo) {
            let index = this.filtros.findIndex(filtro => {
                return filtro.campo.name == campo.name;
            });

            if (index >= 0) {
                this.removerFiltro(index);
            }
        },

        toggle_todos () { 
            let opcao = this.exibirOpcoesFiltro.find(item => {
                return !item.selecionado;
            });

            this.exibirOpcoesFiltro.forEach(item => {
                item.selecionado = opcao;
            });
        },

        addFiltroFromModal() {
            let lista = this.opcoesFiltro
                .filter(item => {
                    return item.selecionado;
                })
                .map(item => {
                    return item.label;
                });

            this.replaceFiltro(this.campoFiltro);

            this.filtros.push({
                campo: this.campoFiltro,
                tipo: this.tipoFiltro,
                valor: lista
            });

            $("#filtroCampoModal").modal("hide");

            this.campoFiltro = null;

            this.refresh_filtro();
        },

        addFiltroModal(lista, campo, titulo, direto = false) {
            this.opcoesFiltro = [];
            this.search =  "";
            this.campoFiltro = { 
                name: campo,
                title: titulo
             };
            this.tipoFiltro = 'A';

            if (!this.campoFiltro || !lista) {
                this.opcoesFiltro = [];
            } else {
                this.opcoesFiltro = _.orderBy(
                    _.map(
                        _.uniqBy(lista, this.campoFiltro.name),
                        (item) => {
                            return { label: item[this.campoFiltro.name], selecionado: direto };
                        }
                    ),
                    "label"
                );
            }

            if ( direto ) { 
                this.addFiltroFromModal();
            } else { 
                $("#filtroCampoModal").modal("show");
            }
        },   
    }
}
</script>
